import type { Template } from "@/types";

export const PO_01_H1_V0: Template[] = [
{
    id: "po-01-h1v0-01",
    name: "PO 01 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_01.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 148, y: 146, width: 839, height: 560, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-02",
    name: "PO 02 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_02.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 64, y: 90, width: 1008, height: 673, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-03",
    name: "PO 03 - H1V0",
    albumType: "Hr",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_03.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 0, y: 90, width: 1136, height: 673, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-04",
    name: "PO 04 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 118, y: 0, width: 900, height: 854, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-05",
    name: "PO 05 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_05.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 55, y: 61, width: 1024, height: 733, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-06",
    name: "PO 06 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_06.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 1136, height: 854, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-07",
    name: "PO 07 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_07.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 568, y: 214, width: 568, height: 425, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-08",
    name: "PO 08 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_08.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 616, y: 251, width: 471, height: 352, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-09",
    name: "PO 09 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_09.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 0, y: 214, width: 568, height: 425, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-10",
    name: "PO 10 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_10.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 49, y: 251, width: 471, height: 352, rotation: 0, imageRotation: 0 }
    ],
}
];